export enum OwnerReportType {
    Booking = 'Booking',
    Occupancy = 'Occupancy',
    Revenue = 'Revenue'
};
